<template>
  <form v-on:submit="isValidAttachment">
    <div class="row">
      <div class="col-md-12 pt-0 pb-0">
        Selecione o anexo
        <input id="input_attachment" class="form-control-file" type="file" />
        <p class="mb-0 mt-3 text-info-img">
          Tamanho máximo <strong>10MB</strong>
        </p>
        <p class="text-info-img">
          Formatos: <strong>PDF, JPG, JPEG, PJPEG</strong> e
          <strong>PNG</strong>
        </p>
      </div>
      <div class="col-md-12 pt-1 pb-0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="col-md-6">
        <v-btn class="btn-cancel" @click="$emit('cancel')" :disabled="loading">
          <i class="fas fa-times mr-2"></i>
          CANCELAR</v-btn
        >
      </div>
      <div class="col-md-6 text-right">
        <v-btn class="btn-save" type="submit" :disabled="loading">
          <i class="fas fa-plus mr-2"></i>
          ADICIONAR</v-btn
        >
      </div>
    </div>
  </form>
</template>

<script>
import moment from "moment";
import ErrorsMessages from "../../../Components/ErrorsMessages";

export default {
  name: "Attachment",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      loading: false,
      errors: [],
    };
  },
  methods: {
    isValidAttachment(event) {
      try {
        event.preventDefault();

        this.loading = true;

        let attachmentForm = document.getElementById("input_attachment");

        let attachment = attachmentForm.files[0];

        if (!attachment) {
          this.loading = false;
          this.errors = [{ message: "Informe o anexo" }];
          return;
        }

        const allowedMimes = [
          "image/jpg",
          "image/jpeg",
          "image/pjpeg",
          "image/png",
          "application/pdf",
        ];

        if (!allowedMimes.includes(attachment.type)) {
          this.loading = false;
          this.errors = [{ message: "Formato de anexo inválido" }];
          return;
        }

        var limitSize = 10 * 1024 * 1024;

        if (attachment.size > limitSize) {
          this.loading = false;
          this.errors = [{ message: "Suportado até 10MB" }];
          return;
        }

        this.loading = false;

        this.$emit("success", {
          id: moment().format("DDHHmmss"),
          name: attachment.name,
          attachment,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>